import React from 'react'
import PropTypes from "prop-types"
import { SVG_NAME_SPACE } from '../../constants/label.constants'

export default function HoverProfileSvg(props) {
  return (
      <svg className={`${props?.color} hover`} xmlns={SVG_NAME_SPACE} width="278.933" height="269.103" viewBox="0 0 278.933 269.103">
      <path d="M248.113 214.161c28.407-39.978 60.015-107.017-19.678-181.441C200.335 6.48 76.506-37.054 20.7 60.473-13.038 119.442-6.747 196.7 48.515 240.649c58.019 46.136 155.643 35.364 199.6-26.488" data-name="Stroke 1 Copy 10"></path>
      </svg>
  )
}
HoverProfileSvg.propTypes = {
  color:PropTypes.string,
}